/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendSupportRequestResponse
 */
export interface SendSupportRequestResponse {
    /**
     * 
     * @type {string}
     * @memberof SendSupportRequestResponse
     */
    conversationId: string | null;
}

/**
 * Check if a given object implements the SendSupportRequestResponse interface.
 */
export function instanceOfSendSupportRequestResponse(value: object): value is SendSupportRequestResponse {
    if (!('conversationId' in value) || value['conversationId'] === undefined) return false;
    return true;
}

export function SendSupportRequestResponseFromJSON(json: any): SendSupportRequestResponse {
    return SendSupportRequestResponseFromJSONTyped(json, false);
}

export function SendSupportRequestResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendSupportRequestResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'conversationId': json['conversationId'],
    };
}

export function SendSupportRequestResponseToJSON(json: any): SendSupportRequestResponse {
    return SendSupportRequestResponseToJSONTyped(json, false);
}

export function SendSupportRequestResponseToJSONTyped(value?: SendSupportRequestResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'conversationId': value['conversationId'],
    };
}

